var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ServicePerson",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-service-person","viewBox":"0 0 518 518"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M454 498.6c-2.5-41.3-12.8-77.3-30.5-107.2-14.3-24-33.3-44.1-56.6-59.6-1.1-.7-2.2-1.5-3.4-2.2 32.3-22.8 45-45.5 46.9-49.1 42.3-64.5 23.5-134.5 22.7-137.4-19.7-70.4-63.9-103.9-97.5-119.5-35.3-16.5-66-17.2-69-17.2-76.6-4-126.4 44.9-130.4 48.9-42.4 38.1-52.2 88.8-53.9 99.6-1 2.8-1.7 6.1-2 10.1L79 216.3s-.7 13.3 14.3 14.7h46.4s-.3-1-.8-2.8c12.5 34.8 39.7 62.7 74.2 76.2-27.2 5-51.3 15.7-72 32.1-21.4 16.9-39.1 39.7-52.5 67.8-22.8 47.4-25.6 93.1-25.8 95l-.4 7.4 392.2-.7-.6-7.4zM99.9 140.9c5.5-19.2 18.2-50.6 45.8-75.4l.4-.3c.5-.5 48-48.7 119.9-44.9h.3c.3 0 29.7.3 63.3 15.9 19.7 9.2 36.9 21.8 51 37.5 17.8 19.6 30.9 44.3 38.9 73.2.2.7 17.9 67.1-21.1 126.3l-.4.7c-.2.3-12.7 24.6-48.1 47.9-17.5-9.2-33.6-14.4-45.1-17.2 48.1-18.4 82.4-65.1 82.4-119.6 0-70.6-57.4-128-128-128C204.1 57 157 92 139 141h-37.6c.1 0-.5-.1-1.5-.1zm45.4 44.1c0-62.9 51.1-114 114-114s114 51.1 114 114-51.1 114-114 114-114-51.1-114-114zM77.4 492.7c1.7-14.5 7.3-48.3 23.7-82.4 12.6-26.2 28.9-47.3 48.6-62.9 24.5-19.4 54.5-30.2 89.1-32.1l.8-.1c.1 0 10-1.7 23.6-1.7 8 0 15.7.6 22.8 1.7l.4.1c.3 0 22.3 2.4 49.5 15.1-7.4 4.1-15.7 8.1-24.8 11.8V337c0-2.2-1.8-4-4-4h-60.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4H307c2.2 0 4-1.8 4-4v-13.8c15.2-5.8 28.3-12.3 39.5-19.1 3 1.8 6.1 3.7 9.1 5.7 21.4 14.3 39 32.9 52 55 15.4 26.1 24.7 57.4 27.8 93.1l-362 .8z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/service-person.svg